//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import cx from 'classnames';

import './CheckboxField.less';

export interface CheckboxFieldProps {
  name?: string;
  label: string;
  description?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: (e: CheckboxChangeEvent) => void;
  className?: string;
}

export const CheckboxField = ({
  name,
  label,
  description,
  checked,
  defaultChecked,
  disabled,
  onChange,
  className,
}: CheckboxFieldProps) => {
  return (
    <Checkbox
      className={cx('synri-checkbox-field', className)}
      name={name}
      checked={checked}
      defaultChecked={defaultChecked}
      disabled={disabled}
      onChange={onChange}>
      <span className="synri-checkbox-field__text">
        <span className="synri-checkbox-field__label">{label}</span>
        {description && (
          <>
            <span className="synri-checkbox-field__separator"> – </span>
            <span className="synri-checkbox-field__description">{description}</span>
          </>
        )}
      </span>
    </Checkbox>
  );
};
